import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEarthAmericas,
  faSignOutAlt,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../App";
import { useCompetitors } from "../context/competitorContext";
import CompetitorList from "../components/Home/CompetitorList";
import Search from "../components/Home/Search";

function HomePage() {
  const { logout } = useAuth();
  const { competitors, loading, error } = useCompetitors();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCompetitors, setFilteredCompetitors] = useState([]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  // Filter competitors in real time as the search query changes r
  useEffect(() => {
    const filtered = competitors.filter((competitor) =>
      competitor.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredCompetitors(filtered);
  }, [searchQuery, competitors]);

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-900 flex items-center justify-center">
        <FontAwesomeIcon
          icon={faCircleNotch}
          className="animate-spin text-4xl text-white"
        />{" "}
      </div>
    );
  }

  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="min-h-screen bg-neutral-900 text-white pb-10 w-full">
      <header className="w-full z-50 relative">
        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="absolute top-4 left-4 px-4 py-2 bg-blue-700 hover:bg-blue-800 
                     transition-colors text-xs duration-200 rounded-lg flex items-center 
                     space-x-2 text-white font-medium shadow-lg hover:shadow-xl"
        >
          <FontAwesomeIcon icon={faSignOutAlt} />
          <span>Logout</span>
        </button>

        <div className="flex flex-col items-center max-w-5xl mx-auto pt-16">
          <div className="flex items-center mb-8">
            <FontAwesomeIcon
              icon={faEarthAmericas}
              className="text-5xl text-blue-700 mr-3"
            />
            <h1 className="text-2xl font-bold">CIA</h1>
          </div>
          <div className="w-1/2">
            <Search searchQuery={searchQuery} onSearchChange={setSearchQuery} />
          </div>
        </div>
      </header>

      <main className="pt-4 px-4">
        <div className="max-w-5xl mx-auto">
          <CompetitorList competitors={filteredCompetitors} />
        </div>
      </main>
    </div>
  );
}

export default HomePage;
